import { entityCreateSignalStore, listStore, resolveStore } from '@frontend/repository';
import { userInterfaceButtonStore } from '@frontend/user-interface-button/redux';
import { userStore } from '@frontend/user/redux';
import { mobileWizardStore } from '@frontend/wizard/mobile';
import { configureStore } from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { mobileNavigationStore } from './mobile-navigation-slice';

export const store = configureStore({
    reducer: {
        ...userInterfaceButtonStore,
        ...userStore,
        ...listStore,
        ...entityCreateSignalStore,
        ...resolveStore,
        ...mobileWizardStore,
        ...mobileNavigationStore
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
